import isEqual from 'lodash/isEqual';
import { AssigneeType } from './AssigneeType';
export class AccessRequest {
    contact;
    accessGroup;
    dataAccess;
    targetId;
    targetType;
    recursive;
    accessGrantMessage;
    constructor(params) {
        this.contact = params.contact;
        this.accessGroup = params.accessGroup;
        this.dataAccess = params.dataAccess;
        this.targetId = params.targetId;
        this.targetType = params.targetType;
        this.recursive = params.recursive;
        this.accessGrantMessage = params.accessGrantMessage;
    }
    getAssignee() {
        return this.contact ?? this.accessGroup;
    }
    getAssigneeId() {
        return this.getAssignee().getAssigneeId();
    }
    isEqual(other) {
        return !!other && isEqual(this.toDto(), other.toDto());
    }
    toDto() {
        const base = {
            dataAccess: this.dataAccess,
            objectId: this.targetId,
            objectType: this.targetType,
            recursive: this.recursive,
            accessGrantMessage: this.accessGrantMessage,
        };
        if (this.contact) {
            return {
                ...base,
                contactEmail: this.contact.email,
            };
        }
        else if (this.accessGroup) {
            return {
                ...base,
                accessGroupId: this.accessGroup.id,
            };
        }
        return base;
    }
    static createForAssignee(assignee, dataAccess, recursive, message, targetId, targetType) {
        const contact = assignee.type === AssigneeType.Contact || assignee.type === 'email'
            ? assignee
            : null;
        const accessGroup = assignee.type === AssigneeType.Group ? assignee : null;
        return new AccessRequest({
            contact,
            accessGroup,
            dataAccess,
            targetId,
            targetType,
            recursive,
            accessGrantMessage: message,
        });
    }
    static fromEntry(entry) {
        return new AccessRequest({
            contact: entry.contact,
            accessGroup: entry.accessGroup,
            dataAccess: entry.dataAccess,
            targetId: entry.id,
            targetType: entry.type,
            // entries always comes from backend and recursive and accessGrantMessage fields are not stored
            recursive: false,
            accessGrantMessage: '',
        });
    }
}
